import { BlueberryProvider } from '@intellihr/blueberry'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const BlueberryDefaultsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()

  return (
    <BlueberryProvider
      theme={undefined} // fallback to internal default
      anchorOnClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        // let the browser handle keyboard modifiers and blank targets
        // TODO: add the url path for more concrete check when URL for the app is defined
        // similar to e.currentTarget.pathname.startsWith('/spa/')
        // check for hc/en-au to ensure help centre link is not considered as internal link
        // TODO: remove check of hc/en-au when the URL for the app is defined
        if (
          !e.currentTarget.pathname.startsWith('hc/en-au') &&
          !e.ctrlKey &&
          !e.metaKey && // windows key and cmd key
          !e.shiftKey &&
          !e.altKey &&
          e.currentTarget.target !== '_blank'
        ) {
          e.preventDefault()
          navigate(e.currentTarget.pathname + e.currentTarget.search + e.currentTarget.hash)
        }
      }}
    >
      {children}
    </BlueberryProvider>
  )
}

export { BlueberryDefaultsProvider }
